export default {
  title: 'Portail des commandes',
  form: {
    username: {
      placeholder: "Nom d'utilisateur",
    },
    password: {
      placeholder: 'Mot de passe',
    },
  },
  buttons: {
    submit: 'Connexion',
  },
  toasts: {
    auth_token_invalid: "Le jeton d'authentification est invalide, veuillez vous connecter avec vos identifiants",
    credentials_invalid: "Nom d'utilisateur ou mot de passe incorrect",
  },
};
